import * as React from 'react';
import $$tracker from '@src/tracker';

const styles = require('./index.less');
const tabImages = {
  MAIN: require('./images/tabs-home.png'),
  GIFT: require('./images/tabs-gift.png'),
  COURSE: require('./images/tabs-course.png')
};

const BottomNav = ({ active }) => {
  const image = tabImages[active];

  return (
    <React.Fragment>
      <img className={styles.spacer} src={image} alt="" aria-hidden="true" />
      <nav className={styles.root} aria-label="活动页面导航">
        <img className={styles.image} src={image} alt="" aria-hidden="true" />
        <a className={styles.item} href="#/" onClick={() => $$tracker.clickActivityHomepage()}>
          <span className={styles.visuallyHidden}>活动首页</span>
        </a>
        <a className={styles.item} href="#/gift" onClick={() => $$tracker.clickValuePack()}>
          <span className={styles.visuallyHidden}>特惠礼包</span>
        </a>
        <a className={styles.item} href="#/course" onClick={() => $$tracker.clickMoreContent()}>
          <span className={styles.visuallyHidden}>更多内容</span>
        </a>
      </nav>
    </React.Fragment>
  );
};

export default BottomNav;
